export enum IUserProperties {
  TOTAL_NUMBER_OF_CONTRACT_CREATED = "totalNumberOfContractCreated",
  TOTAL_NUMBER_OF_CONTRACT_DELETED = "totalNumberOfContractDeleted",
  TOTAL_NUMBER_OF_DELIVERY_CONFIRMED = "totalNumberOfDeliveryConfirmation",
  TOTAL_NUMBER_OF_ESCALATION = "totalNumberOfEscalation",
  TOTAL_NUMBER_OF_INSPECTION_CONFIRMATION = "totalNumberOfInspectionConfirmation",
}
